module.exports = __webpack_public_path__ + "static/media/corporate-services-img95.a4ba1af5.jpg";